import { render, staticRenderFns } from "./hot-topics.vue?vue&type=template&id=6607bdec&scoped=true&"
import script from "./hot-topics.vue?vue&type=script&lang=js&"
export * from "./hot-topics.vue?vue&type=script&lang=js&"
import style0 from "./hot-topics.vue?vue&type=style&index=0&id=6607bdec&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6607bdec",
  null
  
)

export default component.exports